module.exports = __webpack_public_path__ + "static/media/Leanne S.cfd524c6.jpeg";